// extracted by mini-css-extract-plugin
export default {"container":"Slider_container__rDRnY","inner":"Slider_inner__ykwhv","item":"Slider_item__jtutL","indicators":"Slider_indicators__PreKY"};